import { useParams } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { areaMeta } from "@/seo/routeMeta";
import { findTown } from "@/components/site/areaContent";
import { ServiceFaq } from "@/components/service/ServiceExtras";
import { AreaHero, AreaServices, AreaUseCases, AreaWhy, AreaQuote, NearbyAreas } from "@/components/area/AreaSections";
import NotFound from "@/pages/NotFound";

export default function AreaPage() {
  const { slug } = useParams();
  const town = findTown(slug);
  if (!town) return <NotFound />;

  return (
    <div data-testid={`area-page-${town.slug}`}>
      <Seo {...areaMeta(town)} />
      <AreaHero town={town} />
      <AreaServices town={town} />
      <AreaUseCases town={town} />
      <AreaWhy />
      <ServiceFaq content={{ short: town.name, faqs: town.faqs }} />
      <NearbyAreas town={town} />
      <AreaQuote town={town} />
    </div>
  );
}
